/**
 * @generated SignedSource<<3785c8aa73a3094fbd32da405a0fb86d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_IssueNavigatorUI_jqlBuilderWithAiKey$data = {
  readonly " $fragmentSpreads": FragmentRefs<"jqlBuilder_issueNavigator_JQLBuilderWrapper_jqlBuilderWithAiKey" | "main_issueNavigator_IssueResults_rankField">;
  readonly " $fragmentType": "main_issueNavigator_IssueNavigatorUI_jqlBuilderWithAiKey";
};
export type main_issueNavigator_IssueNavigatorUI_jqlBuilderWithAiKey$key = {
  readonly " $data"?: main_issueNavigator_IssueNavigatorUI_jqlBuilderWithAiKey$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigatorUI_jqlBuilderWithAiKey">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_issueNavigator_IssueNavigatorUI_jqlBuilderWithAiKey",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_jqlBuilderWithAiKey"
    },
    {
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_IssueResults_rankField"
    }
  ],
  "type": "JiraQuery"
};

(node as any).hash = "fc51caf86d12b11398947bb77ddb49ca";

export default node;
